import { Routes } from '@angular/router';
import { featureGuard } from './core/tenant/feature.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./components/splash-screen/splash-screen.component').then(m => m.SplashScreen)
    },
    {
        path: 'login',
        loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'register',
        loadComponent: () => import('./components/register/register.component').then(m => m.RegisterComponent)
    },
    {
        path: 'reset',
        loadComponent: () => import('./components/reset/reset.component').then(m => m.ResetComponent)
    },
    {
        // M33: el enlace del correo de bienvenida del alta (/bienvenida?token=…). Misma pantalla que el reset.
        path: 'bienvenida',
        data: { modo: 'bienvenida' },
        loadComponent: () => import('./components/reset/reset.component').then(m => m.ResetComponent)
    },
    {
        path: 'pos',
        canActivate: [featureGuard('ventas')],
        loadComponent: () => import('./components/pos/pos.component').then(m => m.PosComponent)
    },
    {
        // F6.3 — Modo Ruta (el vendedor en la calle). Carga aparte: la caja no baja nada de esto, ni al revés.
        path: 'ruta',
        loadChildren: () => import('./features/ruta/ruta.routes').then(m => m.rutasDeRuta)
    },
    {
        // W1 · Modo Bodega (el bodeguero con el celular). Carga aparte, como Ruta.
        path: 'bodega',
        loadChildren: () => import('./features/bodega/bodega.routes').then(m => m.rutasDeBodega)
    },
    {
        path: 'history',
        canActivate: [featureGuard('historial')],
        loadComponent: () => import('./components/history/history.component').then(m => m.HistoryComponent)
    },
    {
        path: 'closure',
        canActivate: [featureGuard('cierre')],
        loadComponent: () => import('./components/closure/closure.component').then(m => m.ClosureComponent)
    },
    {
        // Z23: el informe del consumo propio. El menú solo lo ofrece si -mt lo ofrece; la puerta es -mt.
        path: 'consumo-propio',
        loadComponent: () => import('./components/consumo-propio/consumo-propio.component').then(m => m.ConsumoPropioComponent)
    },
    {
        path: 'discounts',
        canActivate: [featureGuard('descuentos')],
        loadComponent: () => import('./components/discounts/discounts.component').then(m => m.DiscountsComponent)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
